import { Component, Inject, OnInit } from '@angular/core';
import { SidePanelRef } from '../../../../shared/features/side-panel/models/side-panel-ref';
import { SIDE_PANEL_CONTEXT } from '../../../../shared/features/side-panel/tokens/side-panel.tokens';

@Component({
  selector: 'hub-workspace-edit-confirmation-panel',
  templateUrl: './edit-confirmation-panel.component.html',
  styleUrls: ['./edit-confirmation-panel.component.scss']
})
export class EditConfirmationPanelComponent {

  constructor(@Inject(SIDE_PANEL_CONTEXT) public panelRef: SidePanelRef<{ userId: number; newName: string }>) { }

  confirmAndFinish(): void {
    this.panelRef.close(this.panelRef.data);
  }
}
